<button (click)="clickable ? onClick() : undefined">
   <i
      nz-icon
      nzType="pushpin"
      nzTheme="fill"></i>
</button>
